export default {
    modalQuickActionVariations: {
        title: 'AI ',
        generateWithAi: 'Generer med AI',
        improveWriting: 'Forbedre skrivning',
        fixSpelling: 'Ret skrivning og grammatik',
        simplifyWriting: 'Forenkle skrivningen',
        makeLonger: 'Forlæng',
        makeShorter: 'Forkort eller Gør kortere',
        replaceText: 'Erstat tekst',
        addBelow: 'Tilføj nedenfor',
        cancel: 'Annuller',
        selectQuickActionTitle: 'Fortæl AI, hvad det skal gøre næste gang ...',
        regenerate: 'Regenerere',
    },
};
